import guides from "./guides.json";
import announcementGuides from "./announcements.json";

export { guides, announcementGuides };
export const getGuide = (slug) => guides.find((guide) => guide.slug === slug);
export const normalizeTitle = (title) => (title || "").replace(/^new feature:\s*/i, "").trim().toLowerCase();

export const getLocalGuideUrl = (url) => {
  try {
    const parsed = new URL(url, "https://app.ruebarue.com");
    if (parsed.hostname === "app.ruebarue.com" && parsed.pathname.startsWith("/help/")) {
      return getGuide(parsed.pathname.split("/")[2]) ? parsed.pathname + parsed.hash : null;
    }
    const guide = guides.find((item) => item.sourceUrls.includes(parsed.origin + parsed.pathname) ||
      (parsed.hostname === "intercom.help" && /^\/ruebarue(?:app|-1e04fafac97a)\/en\/articles\//.test(parsed.pathname) &&
        item.articleIds.includes(parsed.pathname.match(/\/articles\/(\d+)/)?.[1])));
    return guide ? `/help/${guide.slug}` : null;
  } catch {
    return null;
  }
};

export const getAnnouncementGuideUrl = (announcement) => {
  const match = announcementGuides.find((item) => normalizeTitle(item.title) === normalizeTitle(announcement.title));
  return match?.path || getLocalGuideUrl(announcement.link);
};
